import * as z from 'zod';

export const LineupFormationPlayerSchema = z.object({
  name: z.string(),
  goals: z.number(),
  assists: z.number(),
});

export const LineupTeamSchema = z.object({
  lines: z.array(z.array(LineupFormationPlayerSchema)),
  bench: z.array(LineupFormationPlayerSchema),
});

const LineupTabResponseSchema = z.object({
  home: LineupTeamSchema,
  away: LineupTeamSchema,
});

export default LineupTabResponseSchema;
